import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { VariableCategory } from './VariableCategory'
import { DeleteComponent } from '../../../../components/general/general-component/abstruct-component/DeleteComponent'
import { deleteCategory, loadCategories } from '../../../../store/Actions/ActionCategory'
import { ColumnCategory } from '../../../../components/general/general-component/columns-component/ColumnCategory'
import SectionTopOfTable from '../../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Table2 from '../../../../components/table/Table2'
import Warning from '../../../../components/general/general-component/warning-delete/Warning'
import AddCategory from './AddCategory'
import EditCategory from './EditCategory'
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader'

const Categories = () => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { categories, loadingCategories } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit, setStateCustom } = VariableCategory()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [categoriesArr, setCategoriesArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    const [isAdded, setIsAdded] = useState(false)
    /*useEffect(() => {
        if (isAdded == true && state.name != "" && state.description != "") {
            console.log('kkkkkkkkkkkkkkkkk')
            const newCategory = {
                name: state.name,
                description: state.description
            };
            setCategoriesArr(prevArr => [...prevArr, newCategory]);
        }
    }, [isAdded]);*/
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...categoriesArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setCategoriesArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, categoriesArr]);
    useEffect(() => {
        if (categories?.length >= 0) {
            setCategoriesArr(categories)
        }
    }, [categories]);

    useEffect(() => {
        dispatch(loadCategories())
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteCategory(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openCategory = e => {
        e.preventDefault()
        setOpen(true)
    }
    const { columns } = ColumnCategory(translate, warning, handleEdit, langLocal)
    return (
        <>
            <>
                {/*<FilterUser translate={translate} />*/}
                {console.log(state)}
                <div className="div_table2" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ position: "relative" }} >
                    <SectionTopOfTable langLocal={langLocal} title={translate('categories')} titleBtn={translate('add_category')} FunctionBtn={openCategory} />
                    {
                        loadingCategories == false ? (
                            <Table2 col={columns} roo={categoriesArr} />
                        ) : <InnerLoader />
                    }
                </div>
            </>
            {
                state.open && (
                    <AddCategory setIsAdded={setIsAdded} state={state} setStateCustom={setStateCustom} open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditCategory arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </>
    )
}

export default Categories
